import React from "react";
import { Field, ErrorMessage } from "formik";
import { useTranslation } from "react-i18next";

const Step3 = () => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-6 bg-[#F6FBFF] mb-6">
      {/* Availability */}
      <div>
        <label htmlFor="availability" className="block text-xs font-semibold text-gray-700 mb-1">
          {t("contractorSignup.form.step3.availabilityLabel", "Availability")}
          <span className="text-red-500">*</span>
        </label>
        <Field
          as="select"
          id="availability"
          name="availability"
          className="bg-[#F1F6F9] border border-gray-300 rounded px-2 py-1 w-full text-sm focus:border-green-500 focus:outline-none transition"
        >
          <option value="">
            {t("contractorSignup.form.step3.availabilityPlaceholder", "Select Availability")}
          </option>
          <option value="full_time">
            {t("contractorSignup.form.step3.availabilityOptions.fullTime", "1-3 Weeks")}
          </option>
          <option value="part_time">
            {t("contractorSignup.form.step3.availabilityOptions.partTime", "3-5 Weeks")}
          </option>
          <option value="freelance">
            {t("contractorSignup.form.step3.availabilityOptions.freelance", "5 Weeks")}
          </option>
        </Field>
        <ErrorMessage name="availability" component="div" className="text-red-500 text-xs mt-1" />
      </div>
      {/* Response Time Commitment */}
      <div>
        <label htmlFor="response_time" className="block text-xs font-semibold text-gray-700 mb-1">
          {t("contractorSignup.form.step3.responseTimeCommitmentLabel", "Response Time Commitment")}
          <span className="text-red-500">*</span>
        </label>
        <Field
          id="response_time"
          name="response_time"
          className="bg-[#F1F6F9] border border-gray-300 rounded px-2 py-1 w-full text-sm focus:border-green-500 focus:outline-none transition"
          placeholder={t(
            "contractorSignup.form.step3.responseTimePlaceholder",
            "e.g. Within 24 hours",
          )}
        />
        <ErrorMessage name="response_time" component="div" className="text-red-500 text-xs mt-1" />
      </div>
      {/* Project Capacity */}
      <div>
        <label
          htmlFor="project_capacity"
          className="block text-xs font-semibold text-gray-700 mb-1"
        >
          {t("contractorSignup.form.step3.projectCapacityLabel", "Project Capacity")}
          <span className="text-red-500">*</span>
        </label>
        <Field
          id="project_capacity"
          name="project_capacity"
          type="number"
          min="0"
          className="bg-[#F1F6F9] border border-gray-300 rounded px-2 py-1 w-full text-sm focus:border-green-500 focus:outline-none transition"
          placeholder={t(
            "contractorSignup.form.step3.projectCapacityPlaceholder",
            "Number of projects you can handle",
          )}
        />
        <ErrorMessage
          name="project_capacity"
          component="div"
          className="text-red-500 text-xs mt-1"
        />
      </div>
      {/* About the Company */}
      <div className="col-span-2">
        <label htmlFor="about_company" className="block text-xs font-semibold text-gray-700 mb-1">
          {t("contractorSignup.form.step3.aboutCompanyLabel", "About the Company")}
        </label>
        <Field
          as="textarea"
          id="about_company"
          name="about_company"
          rows={4}
          className="bg-[#F1F6F9] border border-gray-300 rounded px-2 py-1 w-full text-sm resize-none focus:border-green-500 focus:outline-none transition"
          placeholder={t(
            "contractorSignup.form.step3.aboutCompanyPlaceholder",
            "Describe your company",
          )}
        />
        <ErrorMessage name="about_company" component="div" className="text-red-500 text-xs mt-1" />
      </div>
    </div>
  );
};

export default Step3;
